import ModalComponent from "../modal";
import { useMedia } from "@/hooks/useMedia";
import { Flex } from "@chakra-ui/react";
import Email from "./Email";
import GA from "./GA";
import Phone from "./Phone";

const BXVerify = ({ isShow, validationData, onClose, onOk }) => {
  const { isMobile } = useMedia();
  const { request_id, security_elems } = validationData;

  return (
    <ModalComponent
      isShow={isShow}
      style={{ width: !isMobile ? "450px" : "calc(100% - 30px)" }}
    >
      <Flex justifyContent={"center"} padding={"30px 0px"}>
        {security_elems[0] === "GOOGLE_AUTH" && (
          <GA requestId={request_id} onClose={onClose} onOk={onOk} />
        )}
        {}
        {security_elems[0] === "PHONE" && (
          <Phone requestId={request_id} onClose={onClose} onOk={onOk} />
        )}
        {security_elems[0] === "EMAIL" && (
          <Email requestId={request_id} onClose={onClose} onOk={onOk} />
        )}
      </Flex>
    </ModalComponent>
  );
};

export default BXVerify;
